var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconePositivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8095 11.8568C23.708 12.1618 23.7591 12.4969 23.9471 12.7577C24.135 13.0184 24.4369 13.1729 24.7583 13.1729L38.9601 13.1729C39.771 13.1729 40.5487 13.495 41.1221 14.0684L41.8292 13.3613L41.1221 14.0685C41.6956 14.6419 42.0177 15.4196 42.0177 16.2305L42.0177 20.2996L41.935 20.6844L34.2589 37.5476L13.5853 37.5476L13.5853 11.4225L23.1685 0.999933L23.1857 0.999933C23.1858 0.999933 23.1859 0.999933 23.1859 0.999933C23.6702 1.0001 24.1475 1.11529 24.5786 1.33602C25.0097 1.5568 25.3822 1.87683 25.6654 2.26977C25.9486 2.6627 26.1344 3.1173 26.2075 3.59611C26.2806 4.07491 26.2389 4.56422 26.0859 5.02374C26.0859 5.02376 26.0859 5.02378 26.0859 5.0238L23.8095 11.8568Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52161 37.9529L5.68125 37.9529C4.35379 37.9529 3.1221 37.5681 2.2515 36.9366C1.38563 36.3086 1.00054 35.5377 1.00054 34.8328L1.00054 16.2925C1.00054 15.5876 1.38564 14.8166 2.2515 14.1886L1.66438 13.3791L2.2515 14.1886C3.1221 13.5572 4.35379 13.1724 5.68125 13.1724L7.52161 13.1724L7.52161 37.9529Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePositivo);
export default __webpack_public_path__ + "static/media/icone_positivo.ae04ed3a1129a709c33b13d852893d60.svg";
export { ForwardRef as ReactComponent };